// extracted by mini-css-extract-plugin
export var label = "_6v-1";
export var reminder = "_6v-0";